<button *ngIf="canNudge()" type="button" class="btn btn-sm btn-info" (click)="nudge()" title="Nudge">
    <strong><i class="fas fa-envelope text-primary"></i></strong>
  </button>
  